import React, { useState } from "react";
import { FaBoxOpen, FaGem } from "react-icons/fa";

const PricingDetails = () => {
  const [isYearly, setIsYearly] = useState(false);

  const togglePlan = () => setIsYearly((prev) => !prev);

  return (
    <div className="pricing-container">
      <header className="pricing-header">
        <p className="pricing-subtitle">
          <span /> Pricing Plan <span />
        </p>
        <h1 className="pricing-title">Our Affordable Pricing Plans</h1>
        <div className="pricing-toggle">
          <span className={!isYearly ? "active" : ""}>Monthly</span>
          <div className="toggle-switch" onClick={togglePlan}>
            <div className={`switch-thumb ${isYearly ? "yearly" : ""}`} />
          </div>
          <span className={isYearly ? "active" : ""}>Yearly</span>
          {isYearly && <span className="badge">25% OFF</span>}
        </div>
      </header>

      <div className="pricing-cards">
        {/* Standard Plan */}
        <div className="pricing-card">
          <div className="icon-wrapper">
            <FaBoxOpen />
          </div>
          <h2 className="price">{isYearly ? "₹9k" : "₹1k"}</h2>
          <p className="price-label">{isYearly ? "YEARLY" : "MONTHLY"}</p>
          <div className="plan-label">Standard</div>
          <ul className="features">
            <li>Voice call</li>
            <li>Video call</li>
            <li className="disabled">Psychoeducation</li>
            <li className="disabled">Psychometric Test</li>
            <li className="disabled">People Consulting</li>
            <li className="disabled">Product Consulting</li>
            <li className="disabled">Business Consulting</li>
          </ul>
          <button className="btn">BUY NOW</button>
        </div>

        {/* Premium Plan */}
        <div className="pricing-card">
          <div className="icon-wrapper">
            <FaGem />
          </div>
          <h2 className="price">{isYearly ? "₹18k" : "₹2k"}</h2>
          <p className="price-label">{isYearly ? "YEARLY" : "MONTHLY"}</p>
          <div className="plan-label">Premium</div>
          <ul className="features">
            <li>Voice call</li>
            <li>Video call</li>
            <li>Psychoeducation</li>
            <li>Psychometric Test</li>
            <li>People Consulting</li>
            <li>Product Consulting</li>
            <li>Business Consulting</li>
          </ul>
          <button className="btn">BUY NOW</button>
        </div>

        {/* Custom / Consulting */}
        <div className="pricing-card custom">
          <div className="custom-pricing">
            <div className="tier">
              <h2>
                ₹1k <span>per month</span>
              </h2>
              <p>2 sessions/employee</p>
              <p>1 session psychoeducation</p>
            </div>
            <div className="tier">
              <h2>
                ₹2k <span>per month</span>
              </h2>
              <p>4 sessions/employee</p>
              <p>1 psychometric/employee</p>
              <p>2 sessions psychoeducation</p>
              <p>2 sessions group coaching</p>
            </div>
          </div>
          <h3 className="consulting">Consulting 2K/hourly</h3>
        </div>
      </div>
    </div>
  );
};

export default PricingDetails;
